import React from "react";

interface Props {
    label?: string;
}
export const FilterLabel: React.FC<Props> = ({ label }) => <>{label}</>;
